import { Component } from '@angular/core';
import { Router } from '@angular/router';



@Component({
  selector: 'app-property-division-form-pf',
  templateUrl: './property-division-form-pf.component.html',
  styleUrls: ['./property-division-form-pf.component.scss'],
})
export class PropertyDivisionFormPfComponent {

  constructor(private router: Router) {
  }


  backStep() {
    this.router.navigateByUrl('forms-list');

  }


}
